"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'cashpledge',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      stat_data: {},
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        start: 1,
        total: 10,
        page_num: 1,
        limit: 20
      }
    };
  },
  computed: {
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    }
  },
  mounted: function mounted(options) {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get('agentapi/withdaw_deposit_orders', listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.stat_data = res.stat_data;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 点击退押金
     */
    refundDeposit: function refundDeposit(row) {
      var _this2 = this;
      this.$alert('确定退还该订单押金吗？', '押金退还', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            var url = 'agentapi/agent_back_wxuser_deposit';
            if (row.mini_type == 2) url = 'agentapi/agent_back_zfbuser_deposit';
            _this2.$post(url, {
              order_id: row.id,
              task_id: row.task_id
            }).then(function (res) {
              // 【操作埋点】2026-05-25 pc_withdraw_deposit_refund_1 退还用户押金
              _this2.$withdrawReport.reportWithdrawDepositRefund(row.id, row.task_id, row.mini_type == 2 ? '支付宝' : '微信');
              _this2.$message({
                message: '退还成功',
                type: 'success'
              });
              row.deposit_status = 1;
            });
          }
        }
      });
    }
  }
};